import $ from 'jquery';
export default class SimpleAjaxForm {
    static init() {
        $(document).on('submit', '.js__simple-ajax-form', event => {
            event.preventDefault();
            const $form = $(event.currentTarget);
            $.ajax({
                method: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
            })
                .done(data => {
                $($form.data('content-load-selector')).html(data);
            })
                .fail(xhr => {
                $($form.data('content-load-selector')).html(xhr.responseText);
            });
        });
    }
}
